var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover"},[_c('img',{staticClass:"waiting",attrs:{"src":require("@/assets/loading.gif")}}),_c('h1',[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []

export { render, staticRenderFns }